import React from 'react'
import { Card } from 'react-bootstrap'
import { EmojiSmileUpsideDown } from 'react-bootstrap-icons'
import './notfound.css';

export const NotFound = () => {
  return (
        <Card id='container' className='border-0'>
          <Card.Body>
            <p className='form-text text-center m' style={{fontSize: '4rem'}}> 404 Not Found</p>
            <h1 className='text-center text-warning mt-4 p-2' style={{fontSize: '3.5rem'}}>
            <EmojiSmileUpsideDown/>
              <br />
              Emprendedor no encontrado  
            </h1>
          </Card.Body>
        </Card>
  )
}

